import { render, staticRenderFns } from "./CheckingBox.vue?vue&type=template&id=1f1ad4e8&scoped=true"
import script from "./CheckingBox.vue?vue&type=script&lang=js"
export * from "./CheckingBox.vue?vue&type=script&lang=js"
import style0 from "./CheckingBox.vue?vue&type=style&index=0&id=1f1ad4e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1ad4e8",
  null
  
)

export default component.exports